import { OnInit, Input, Output, EventEmitter, Component } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'iw-button-view-form-dynamic',
  template: '<button class="btn btn-warning btn-xs mb-1"(click)="onClick(\'view\')">ver</button>' ,
  styles: [`
        .btn-xs {
          font: 400 10.3333px Arial !important;
        }
    `]
})
export class ButtonsActionsTableHelpsComponent implements ViewCell, OnInit {
  // contiene el valor de entrada
  renderValue: number;
  // entrada del valor del boton
  @Input() value: number;
  // entrada de la fila a la cual se le dio click
  @Input() rowData: any;
  // salida del evento del click
  @Output() save: EventEmitter<any> = new EventEmitter();
  


  ngOnInit() {
    this.renderValue = this.value;
  }
  /**
   * Emite el evento retornando la data de la fila selecionada al dar click en el boton
   *
   * @memberof ButtonsActionsTableHelpsComponent
   */
  onClick(action: string = 'view') {
      const dataEmit = {
        'action': action,
        'data': this.rowData
      };
      this.save.emit(dataEmit);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/buttons-actions-table-helps.component.ts